import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  IAdminSettingsPaymentCountryGroupItemPayload,
  IAdminSettingsPaymentCountryGroupItemResponse,
} from '../types';
import {
  SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_QUERY_KEY,
  SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_URL,
} from '../constants';

export default function useSettingsPaymentCountryGroupsItemQuery(
  payload: Ref<IAdminSettingsPaymentCountryGroupItemPayload>,
): IContextQueryResult<IAdminSettingsPaymentCountryGroupItemResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAdminSettingsPaymentCountryGroupItemResponse, Error>({
    queryKey: [SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchGet(SETTINGS_PAYMENT_COUNTRY_GROUPS_ITEM_URL, {
      signal,
      urlParams: {
        id: payload.value.id,
      },
    }),
    enabled: false,
    placeholderData: keepPreviousData,
  });
}
